import core from '@gin-betting/core';
import moduleLocator from 'moduleLocator';

const {
    utils: { measureTime },
    hocs: { withAsyncLoad },
} = core;

export const loadSearchModule = () =>
    import(/* webpackChunkName: "search-module" */ './index').then(
        searchModule => {
            measureTime('searchModuleLoaded');

            moduleLocator.set('search', searchModule);

            return searchModule;
        }
    );

// TODO:  AsyncSearchInput, SearchInput should be removed if it outdated component.
// export const AsyncSearchInput = withAsyncLoad({
//     loader: loadSearchModule,
//     loading: () => null,
//     componentToRender: 'SearchInput',
// });

export const AsyncSearchMobile = withAsyncLoad({
    loader: loadSearchModule,
    loading: () => null,
    componentToRender: 'SearchMobile',
});
